// extracted by mini-css-extract-plugin
export default {"surface":"styles_surface__qlhRz","surface-border":"styles_surface-border__h8CM9","video":"styles_video__-hFL1"};